/* eslint-disable import/no-unresolved */
import React from 'react';
import { isEmpty } from 'lodash';
import { SELECT_FUND } from 'common/constants/funds';
import { CustomSelect, withTooltip } from 'components';
import { useFeatureSpreadsheet } from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import { useFundOwnershipContext } from 'context/FundOwnershipContext';
import { toString } from 'utilities';
import FundEntityListProps from './FundEntityList.props';
import fundEntityListStyles from './FundEntityList.styles';

const FundEntityList = ({ cell, ...restProps }: FundEntityListProps) => {
  const { onCommit, onRevert } = restProps;
  const { onCellsChanged } = useFeatureSpreadsheet();
  const { fundEntityListValues } = useFundOwnershipContext();

  const handleChange = (value: string | null) => {
    const newValue = value !== null ? toString(value) : '';
    onCellsChanged([{ cell, value: newValue }]);
  };

  if (!cell.columnLegend || isEmpty(fundEntityListValues[cell.columnLegend])) {
    return <div>No funds available</div>;
  }

  return (
    <CustomSelect
      id={`security-list-${cell.key}`}
      value={cell.value as string}
      options={fundEntityListValues[cell.columnLegend!]}
      onChange={handleChange}
      onCommit={(value: string | null) => onCommit?.(value ?? '')}
      onRevert={onRevert}
      onEmptyValue={SELECT_FUND}
      disabled={cell.readOnly}
      extraStyles={fundEntityListStyles}
      usePortal
    />
  );
};

export default withTooltip(FundEntityList);
